import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
declare var google: any;
@Component({
  selector: 'app-location-search-with-maps',
  templateUrl: './location-search-with-maps.component.html',
  styleUrls: ['./location-search-with-maps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationSearchWithMapsComponent implements OnInit, OnChanges {
  @Input() control: FormGroup;
  @Input() controlformatedAddress: FormControl;
  @Input() patchedData;
  @Input() isSearchLocation = true;
  @Input() height: any = '300px !important';
  @Input() width: any = '100%';
  @Input() isLabel = true;
  @Input() helperGeoLocation = false;
  @Input() cols = 12;
  @Input() adressControls: FormGroup;
  @Input() isAdressControls = false;
  @Input() showMap = true;
  @Input() label: 'Geo location';
  @Input() placeholder = 'Enter Area or Locality';
  @Input() labelFontSize;
  @Output() geoAddress = new EventEmitter();
  @Input() customInputClass = '';
  @Input() enableEnterLatLng = false;
  locationForm: FormGroup;

  locating = false;
  mapsClass = 'maps';
  map;
  marker;

  constructor(
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.locationForm = this.fb.group({
      lat: [null, [Validators.required]],
      lng: [null, [Validators.required]]
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    this.cdr.markForCheck();
    if (changes.patchedData) {
      this.patchedDataMap();
    }
  }

  ngOnInit() {
    this.map = new google.maps.Map(
      document.getElementById('map') as HTMLElement,
      {
        center: { lat: 28.6862738, lng: 77.2217831 },
        zoom: 5,
        mapTypeControl: false,
        streetViewControl: false,
        draggable: true
      }
    );
    this.initMap();
  }

  patchedDataMap() {
    if (this.patchedData && this.patchedData.coordinates && this.patchedData.coordinates.length) {
      const latLng = this.patchedData.coordinates;
      if (latLng[1] && latLng[0]) {
        this.mapsClass = this.showMap ? 'maps visible' : 'maps';
        this.geocodeLatLng(latLng[1], latLng[0], true);
      }
    }
  }

  initMap(): void {
    const input = document.getElementById('pac-input') as HTMLInputElement;
    const autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.bindTo('bounds', this.map);
    autocomplete.setComponentRestrictions({
      country: ["in"]
    });
    autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
    const infowindow = new google.maps.InfoWindow();
    const infowindowContent = document.getElementById('infowindow-content') as HTMLElement;
    infowindow.setContent(infowindowContent);
    this.marker = new google.maps.Marker({
      map: this.map,
      draggable: true,
      animation: google.maps.Animation.DROP,
      anchorPoint: new google.maps.Point(0, -29),
    });
    google.maps.event.addListener(this.marker, 'dragend', this.locateMe);
    autocomplete.addListener('place_changed', () => {
      infowindow.close();
      this.marker.setVisible(false);
      const place = autocomplete.getPlace();
      if (!place.geometry) {
        window.alert(`${'No details available for input: '}` + place.name + '');
        return;
      }
      this.getLatlong(place.geometry);
    });
  }

  getLatlong(event) {
    this.locateMe(event.location, false);
  }

  locateMe(location?, clicked?) {
    this.mapsClass = this.showMap ? 'maps visible' : 'maps';
    this.locating = true;
    if (location) {
      const latitude = (location.lat && location.lat()) || (location.latLng && location.latLng.lat());
      const longitude = (location.lng && location.lng()) || (location.latLng && location.latLng.lng());
      this.geocodeLatLng(latitude, longitude, clicked === false ? false : true);
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((res: any) => {
        this.geocodeLatLng(res.coords.latitude, res.coords.longitude, clicked === false ? false : true);
      });
    }
  }
  geocodeLatLng(latitude, longitude, clicked) {
    if (this.control.get('coordinates')) {
      this.control.get('coordinates').setValue([longitude, latitude]);
    }
    const geocoder = new google.maps.Geocoder();
    const infoWindow = new google.maps.InfoWindow();
    const latlng = {
      lat: parseFloat(latitude),
      lng: parseFloat(longitude),
    };
    geocoder.geocode({ location: latlng }, (results: any, status: any) => {
      if (status === 'OK') {
        if (results[0]) {
          this.map.setZoom(18);
          this.map.setCenter(latlng);
          this.marker.setVisible(false);
          this.marker = new google.maps.Marker({
            draggable: true,
            position: latlng,
            map: this.map,
            anchorPoint: new google.maps.Point(0, -29),
          });
          this.locating = false;
          google.maps.event.addListener(this.marker, 'dragend', this.locateMe.bind(this));
          const infowindowContent = document.getElementById('infowindow-content') as HTMLElement;
          infoWindow.setContent(infowindowContent);
          infoWindow.setContent(results[0].formatted_address);
          infowindowContent.children['place-address'].textContent = `Latitude:  ${results[0].geometry.location.lat()}  | longitude: ${results[0].geometry.location.lng()}`;
          infoWindow.open(this.map, this.marker);
          if (this.isAdressControls) {
            this.getAddressControls(results[0]);
          }
          if (this.controlformatedAddress) {
            this.controlformatedAddress.setValue(results[0].formatted_address);
          }
          if (clicked) {
            const element = document.getElementById('pac-input') as HTMLElement;
            element['value'] = results[0].formatted_address;
          }
          this.locating = false;
          this.cdr.markForCheck();
        } else {
          // window.alert('No results found');
          this.locating = false;
        }
      } else {
        // window.alert('Geocoder failed due to: ' + status);
        this.locating = false;
      }
    }
    );
  }

  getAddressControls(object) {
    this.locating = false;
    const address: any = {};
    const address_components = object.address_components;
    address_components.forEach(element => {
      address[element.types[0]] = element.long_name;
    });
    const addressControl = {
      // state: address.administrative_area_level_1 || '',
      // district: address.administrative_area_level_3 || address.administrative_area_level_2 || address.locality || address.political || '',
      // subDistrict: address.political || address.locality || '',
      pincode: address.postal_code || '',
      location: {
        latitude: object.geometry.location.lat().toString(),
        longitude: object.geometry.location.lng().toString(),
      },
      formatedAddress: object.formatted_address || ''
    };
    this.geoAddress.emit(addressControl);
    if (this.adressControls && this.adressControls.value) {
      this.adressControls.patchValue(addressControl);
    }
    this.cdr.markForCheck();
  }
  editLatLng() {
    Helpers.openModal('latLong');
  }
  saveLatLng() {
    if(this.locationForm.invalid) {
      return;
    }
    this.geocodeLatLng(this.locationForm.get('lat').value, this.locationForm.get('lng').value, true)
    this.showMap = true;
    this.mapsClass = 'maps visible';
    Helpers.closeModal('latLong');
  }
}


